module.exports = __webpack_public_path__ + "assets/img/09ef8bbf0c4a5a1bd267a97b7cd86eb0.png";